import { adaptBoolean, adaptHtml, adaptSelector } from 'adapters/base';

export const adaptTextCTA = (component, language) => {
  try {
    return {
      id: component.path,
      type: 'text_cta',
      controlId: component.controlId,
      fields: {
        text: adaptHtml(component.contentFields[0], 'text', language),
        cta: adaptCta(component.contentFields[0], 'cta', language)[0] ?? [],
        position: adaptSelector(component.contentFields[0], 'position', language, 'center'),
        size: adaptSelector(component.contentFields[0], 'size', language, 'medium'),
        animation: adaptSelector(component.contentFields[0], 'animation', language, 'ease_in'),
        fullHeight: adaptBoolean(component.contentFields[0], 'isFullHeight', language, false),
        backgroundColor: adaptHtml(component.contentFields[0], 'background_color', language, 'transparent'),
        marginBottom: adaptSelector(component.contentFields[0], 'margin_bottom', language, 'margin__bottom__160'),
      },
    };
  } catch (e) {
    console.error('Error adapting TextCta component', e);
    return null;
  }
};

export const adaptCta = (contentFields, path, language) => {
  if (!contentFields) return [];

  const contentField = contentFields.find((contentField) => contentField.path === path);

  if (!contentField?.contentFields) return [];

  return contentField.contentFields.map((field) => {
    return {
      text: adaptHtml(field, 'cta_text', language, ''),
      link: adaptHtml(field, 'cta_link', language, ''),
      newTab: adaptBoolean(field, 'cta_target', language, false),
    };
  });
};
